import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, useHistory } from 'react-router-dom';
import { useMount } from 'react-use';

import { compilePath } from '../../../../common/utils/helpers/routes';
import {
  selectActiveItem,
  selectActiveItemIndex,
} from '../../../item-details/store';
import { selectSearchParams } from '../../../../common/store/search';
import { selectGeolocation } from '../../../../map/store';
import CloseOrRemove from '../close-or-remove/CloseOrRemove';
import {
  clearLastSentEditMetadata,
  longPressLocationChanged,
  setLastSentEditMetadata,
} from '../../../../common/store/item-edit';
import {
  getItemEditSuggestionType,
  getItemType,
} from '../../../../common/utils/helpers/item';

const CloseOrRemovePage = ({ ...props }) => {
  const searchParams = useSelector(selectSearchParams);
  const item = useSelector(selectActiveItem);
  const searchSelectedFeatureIndex = useSelector(selectActiveItemIndex);
  const geolocation = useSelector(selectGeolocation);
  const history = useHistory();
  const startEditTimestampRef = useRef<number>();

  const dispatch = useDispatch();
  useMount(() => {
    dispatch(clearLastSentEditMetadata());
    dispatch(longPressLocationChanged(null));
  });

  useEffect(() => {
    if (item) {
      startEditTimestampRef.current = Date.now();
    }
  }, [item]);

  if (!item) {
    return (
      <Redirect
        to={{
          pathname: compilePath('results-list'),
          search: history.location.search,
        }}
      />
    );
  }

  return (
    <>
      <CloseOrRemove
        {...props}
        searchSelectedFeatureIndex={searchSelectedFeatureIndex}
        searchQuery={searchParams && searchParams.query}
        userLocation={geolocation}
        item={item}
        onSubmit={(editSuggestionSendingResult) => {
          dispatch(
            setLastSentEditMetadata({
              startEditTimestamp: startEditTimestampRef.current!,
              feedbackType: `close or remove ${getItemType(item)!.replace(
                '-',
                ' ',
              )}`,
              editSuggestionId: editSuggestionSendingResult.editSuggestionId,
              featureType: getItemEditSuggestionType(item),
            }),
          );

          // don't push as it should return back to the same step as from close or remove
          history.replace({
            pathname: compilePath('thank-you'),
            search: history.location.search,
          });
        }}
        onCancel={() => history.goBack()}
      />
    </>
  );
};

export default CloseOrRemovePage;
